import { render, staticRenderFns } from "./security.vue?vue&type=template&id=0afaa486&scoped=true"
import script from "./security.vue?vue&type=script&lang=js"
export * from "./security.vue?vue&type=script&lang=js"
import style0 from "./security.vue?vue&type=style&index=0&id=0afaa486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afaa486",
  null
  
)

export default component.exports